import type React from 'react';
import appleIcon from '~/static/assets/icons/landing-page/apple_icon.svg';
import googlePlayIcon from '~/static/assets/icons/landing-page/google_play.svg';
import { mobileAppRedirectService } from '../../../services/mobileAppRedirectService';
import type { MobilePlatform } from '../../../utils/mobilePlatform';

const STORE_ICONS: Record<MobilePlatform, ImageAsset> = {
  ios: appleIcon,
  android: googlePlayIcon,
};

interface StoreLinkProps {
  platform: MobilePlatform;
}

export const StoreLink: React.FC<StoreLinkProps> = ({ platform }) => {
  const icon = STORE_ICONS[platform];

  return (
    <a
      href={mobileAppRedirectService.getStoreUrl(platform)}
      target="_blank"
      rel="noopener noreferrer"
      className="mobile-app-redirect__button mobile-app-redirect__button--secondary"
    >
      <img
        src={icon.src}
        width={icon.width}
        height={icon.height}
        alt=""
        className={`mobile-app-redirect__store-icon mobile-app-redirect__store-icon--${platform}`}
        aria-hidden={true}
      />
      Download app
    </a>
  );
};
